// src/pages/Login.js
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Login() {
  const { signIn } = useAuth();  // <-- from AuthContext
  const navigate = useNavigate();

  // State to hold input values
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Attempt to log in with the provided email & password
  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form refresh
    try {
      await signIn(email, password);
      console.log("Login successful!");
      navigate("/scheduler"); // Redirect on success
    } catch (error) {
      console.error("Login failed:", error);
      alert("Login failed: " + error.message);
    }
  };

  return (
    <div>
      <h2>Login</h2>

      {/* Basic login form */}
      <form onSubmit={handleLogin}>
        <div style={{ marginBottom: "10px" }}>
          <label>Email:</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginLeft: "10px" }}
          />
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label>Password:</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ marginLeft: "10px" }}
          />
        </div>

        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default Login;
